<div ohpInstrumentPageView="Home_PageView">
    <div role="main">
        <ohp-documents-component [firstSection]="true" [headless]="true" [isSuggestedActions]="showSuggestedActions"></ohp-documents-component>
        <ng-container *ngIf="showPlaces" ohpLazyView ngModulePath="places#PlacesModule"></ng-container>
    </div>
</div>
